import React from 'react';
import styles from './CalcEmptyListBlock.module.scss';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
import { URL_CALCS_NEW } from 'constants/calculatorsPage';

const CalcEmptyListBlock = ({ collectionName, children }) => {
  const navigate = useNavigate();

  const getChildren = () => {
    if (children) return children;
    return (
      <>
        You don&apos;t have {collectionName} yet.
        <br />
        {'Start your company '}
        <Link onClick={() => navigate(URL_CALCS_NEW)}>Self-assessment</Link>
        {' process.'}
      </>
    );
  };

  return <div className={clsx(styles.container, styles.empty)}>{getChildren()}</div>;
};

export default CalcEmptyListBlock;
